import { useAppState } from '../hooks/useAppState';
import type { Page } from '../types';

interface TabConfig {
  label: string;
  page: Page;
}

const tabs: TabConfig[] = [
  { label: '首页', page: 'splash' },
  { label: '推荐', page: 'sceneFlow' },
  { label: '全部', page: 'allScenes' },
];

export function BottomNav(): JSX.Element {
  const { state, navigate } = useAppState();

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '52px',
        backgroundColor: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        paddingBottom: 'calc(8px + env(safe-area-inset-bottom))',
        zIndex: 50,
      }}
    >
      {tabs.map((tab) => {
        const isActive = state.currentPage === tab.page;
        return (
          <button
            key={tab.page}
            onClick={() => navigate(tab.page)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              flex: 1,
              height: '100%',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: isActive ? '#1a1a1c' : '#a1a1a6',
              transition: 'color 0.3s cubic-bezier(0.22, 1, 0.36, 1)',
              fontSize: '11px',
              fontWeight: isActive ? 600 : 400,
              letterSpacing: '0.06em',
              position: 'relative',
            }}
          >
            {tab.label}
            {isActive && (
              <div
                style={{
                  position: 'absolute',
                  top: '6px',
                  width: '3px',
                  height: '3px',
                  borderRadius: '50%',
                  backgroundColor: '#1a1a1c',
                }}
              />
            )}
          </button>
        );
      })}
    </nav>
  );
}
